import { FlexibleColumn } from '@ip-only/front-end-library';

export const reportsPanelColumns: FlexibleColumn[] = [
  { id: 'name', header: 'report.reportHeaders.name', narrow: true },
  { id: 'status', header: 'report.reportHeaders.status', narrow: true },
];
